export default __webpack_public_path__ + "static/media/noun_profile_1543006.97fdce78.svg";